import React from 'react'

const UserEdit: React.FC<DefaultPropsIcon> = (props) => {
  const { size = 20, onClick, className, color = '#6E7191' } = props

  return (
    <span className={['anticon', 'anticon-setting', className || ''].join(' ')} onClick={onClick}>
      <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="7.5" cy="5.5" r="3" stroke={color} strokeWidth="1.8" />
        <path
          d="M2.5 16.5C2.5 13.35 4.55 11 8 11C9.1 11 10.05 11.23 10.85 11.65"
          stroke={color}
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <path
          d="M12.55 16.8L15.95 13.4C16.45 12.9 17.25 12.9 17.75 13.4C18.25 13.9 18.25 14.7 17.75 15.2L14.35 18.6L11.85 19.3L12.55 16.8Z"
          stroke={color}
          strokeWidth="1.6"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  )
}

export default UserEdit
